export class ApiError extends Error {
    public constructor(public readonly status: number, message: string) {
        super(message);
    }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
    const response = await fetch(path, {
        ...init,
        credentials: "same-origin",
        headers: {
            ...(init.body ? { "Content-Type": "application/json" } : {}),
            ...init.headers,
        },
    });
    if (response.status === 204) return undefined as T;
    const payload = await response.json().catch(() => ({ error: response.statusText })) as {
        error?: string;
        message?: string;
    };
    if (!response.ok) throw new ApiError(response.status, payload.message ?? payload.error ?? "Request failed");
    return payload as T;
}

export function body(value: unknown): Pick<RequestInit, "body"> {
    return { body: JSON.stringify(value) };
}
